import { Card } from 'customer_portal-ui-shared';
import React, { useEffect, useState } from 'react';
import { DocumentType, PrintMode } from '../../constants';
import { IRegulation } from '../../contracts/amendment.contract';
import { useAppSelector } from '../../hooks';
import { RegulationDropDown, RegulationPrint } from '../shared';
import regulationFilterText from '../shared/regulation-filter-text';
import { Typography } from '@mui/material';

// Stable references so selector fallbacks don't create a new array every render
const EMPTY_REGULATIONS: IRegulation[] = [];
const EMPTY_VESSELS: any[] = [];
const EMPTY_CLASS_NUMBERS: string[] = [];

const VesselCriteriaSummary = () => {
    const regulations: IRegulation[] = useAppSelector((state) => state.Regulation.ByVessel.Regulations) ?? EMPTY_REGULATIONS;
    const criteria = useAppSelector((state) => state.Criteria.TrackerCriteria);
    const vessels = useAppSelector((state) => state.Vessel.List.Vessels) ?? EMPTY_VESSELS;
    const vesselCriteriaInput = useAppSelector((state) => state.Vessel.UserSearchQuery) ?? '';
    const classNumbers = useAppSelector((state) => state.Regulation.ByVessel.Filters.ClassNumbers) ?? EMPTY_CLASS_NUMBERS;
    const [printMode, setPrintMode] = useState<string>('');
    const [filteredRegulations, setFilteredRegulation] = useState<IRegulation[]>([]);

    useEffect(() => {
        const vesselNames = vessels.filter((vessel) => classNumbers.includes(vessel.ClassNumber)).map((vessel) => vessel.VesselName);
        setFilteredRegulation(regulationFilterText(vesselCriteriaInput, regulations));

        if (printMode === PrintMode.Print || printMode === PrintMode.View) {
            RegulationPrint({ filteredRegulations: regulationFilterText(vesselCriteriaInput, regulations), filters: criteria, documentType: DocumentType.Vessel, printMode, vesselNames });
            setPrintMode(''); // Reset printMode after action
        }
    }, [printMode, regulations, criteria, vessels, classNumbers, vesselCriteriaInput]);

    if (filteredRegulations.length === 0) {
        return <div>No regulations available.</div>;
    }

    const amendmentsLength = filteredRegulations.flatMap((f) => f.Amendments).length;

    const data = {
        title: {
            content: (
                <>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }}>
                        The Regulatory Tracker is an interactive platform designed to provide the latest developments arising from the International Maritime Organization (IMO). The current version
                        has been updated to reflect the forthcoming requirements up to the IMO decisions in June 2025.
                    </Typography>
                    <h5 style={{ marginTop: '18px' }}>
                        Showing {amendmentsLength} amendments across {filteredRegulations.length} regulations.
                    </h5>
                </>
            )
        },
        body: (
            <div style={{ width: '100%' }}>
                <RegulationDropDown
                    regulations={filteredRegulations}
                    filters={criteria}
                    vesselNames={vessels.map((v) => v.VesselName)}
                    documentType={DocumentType.Vessel}
                    printMode={printMode}
                    setPrintMode={setPrintMode}
                />
            </div>
        )
    };

    return (
        <div style={{ width: '100%' }}>
            <Card data={data} tag="h5" />
        </div>
    );
};

export default VesselCriteriaSummary;
